import React from 'react';
import AppNavigationLink from "./AppNavigationLink";

export default function BottomNavigationView({
    currentPath,
    links,
    onNavigateToLink,
}) {
    return (
        <div className="main-menu" id="main-menu">
            <div className="nav-items" id="nav-items">
                {links.map((link) => (
                    <AppNavigationLink
                        key={link.key}
                        {...link}
                        currentPath={currentPath}
                        onClick={onNavigateToLink(link.href)}
                        isMenuOpen={false}
                        href={link.href}
                    />
                ))}
            </div>
        </div>
    );
}
